const PermissionMenu = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "menu": "القائمة",
    "sub_menu": "القائمة الفرعية",
    "action_name": "اسم الإجراء",
    "api": "واجهة برمجة التطبيقات",
    "permission": "الإذن",
    "route": "المسار",
    "show_in_menu": "إظهار في القائمة",
    "search": "بحث",

    // PAGE HEADER
    "permisiion_menu": "قائمة الأذونات",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_menu": "الرجاء تحديد القائمة",
    "error_sub_menu": "الرجاء تحديد القائمة الفرعية",
    "error_action_name": "الرجاء إدخال اسم الإجراء",
    "error_route_required": "الرجاء إدخال المسار",
    "error_route_matches": "الرجاء إدخال مسار صحيح",
    "error_show_in_menu": "الرجاء تحديد إظهار في القائمة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_main_menu": "القائمة الرئيسية",
    "table_sub_menu": "القائمة الفرعية",

}

export default PermissionMenu;